/**
 * .tuMetrics {"tu1": 0.9, "tu2": 0.88, "tu3": 2, "notes": "Fire-and-forget TeamBots wake on card assign (one-shot)", "tuVersion": "2.5"}
 * .help "When a TeamBots agent is assigned a non-draft card, start currents_wake; cron poller finishes the job."
 */
import type { Card } from '../../types';
import useUserStore from '../../store/userStore';
import { startTeamBotsWakeOnly } from './wakeRunner';

function cardUrlFor(cardId: string): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/cards/${cardId}`;
  }
  return `https://currents.build/cards/${cardId}`;
}

/**
 * If assignee is a connected TeamBots agent, start OpenClaw wake (no browser poll).
 * Never throws to the caller — assign UI must not fail because wake failed.
 */
export function maybeWakeTeamBotsOnAssign(card: Card, assigneeId: string | null | undefined): void {
  if (!assigneeId || card.is_draft) return;

  const { currentUser, allUsers } = useUserStore.getState();
  if (!currentUser?.companyId) return;

  const assignee = allUsers.find((u) => u.id === assigneeId);
  if (!assignee?.isAgent) return;
  if (assignee.externalAgentSource !== 'teambots' || !assignee.teambotsAgentId) return;

  void startTeamBotsWakeOnly({
    companyId: currentUser.companyId,
    localAgentId: assignee.id,
    actorName: currentUser.casualName || currentUser.name,
    senderId: currentUser.id,
    cardId: card.id,
    cardUrl: cardUrlFor(card.id),
    replyTarget: 'card',
    logLabel: 'card-assign',
  });
}
